export const environment = {
  production: false,
  sessionExamTime: 10,
  // DEV
  // appUrl: 'https://consumervoice.expertapps.com.sa',
  // voiceAdminUrl: 'https://consumervoiceadmin.expertapps.com.sa',
  // apiUrl: 'https://consumervoicegateway.expertapps.com.sa/api',
  // signalR: 'https://consumervoiceslr.expertapps.com.sa',

  // // consumervoicegateway URLs
  // voiceAdminUrl: 'https://consumervoiceadmin.expertapps.com.sa',
  // appUrl: 'https://consumervoice.expertapps.com.sa',
  // apiUrl: 'https://consumervoicegateway.expertapps.com.sa/api',
  // signalR: 'https://consumervoiceslr.expertapps.com.sa',

  // TEST
  // voiceAdminUrl: 'https://consumervoicetestadmin.expertapps.com.sa',
  // appUrl: 'https://consumervoicetest.expertapps.com.sa',
  // apiUrl: 'https://consumervoicetestgateway.expertapps.com.sa/api',
  // signalR: 'https://consumervoicetestslr.expertapps.com.sa/hubs',

  // Production
  // voiceAdminUrl: 'https://consumervoiceadmin.cpa.sa',
  // appUrl: 'https://consumervoice.cpa.sa',
  // apiUrl: 'https://consumervoicegw.cpa.sa/api',
  // signalR: 'https://consumervoiceslr.cpa.sa/hubs',

  // consumervoicegateway URLs
  voiceAdminUrl: 'https://consumervoiceadmin.expertapps.com.sa',
  appUrl: 'https://consumervoice.expertapps.com.sa',
  apiUrl: 'https://consumervoicedev2gw.expertapps.com.sa/api',
  signalR: 'https://consumervoiceslr.expertapps.com.sa/hubs',


  googleSiteKey: '6Lcz56QqAAAAAPhEQkyFr0KBNtpRj-dc-GcxQL2c',
  googleApiKey: '6Lcz56QqAAAAANCi0wq8xYHwBCc7YIS_3qpeo9dE',
  googleClientId: '321058224199-ep81fdnrm8qoucp9dc45ep7c85lsebpm.apps.googleusercontent.com',
  apple: {
    loginUrl: 'https://consumervoiceapi.expertapps.com.sa/api/auth/apple/login?platform=web',
  },
  hideCourseId: 222
};
